import sharedConstants from "@lib/shared_constants.json";

export const getChunkEventName = (jobToken: string) =>
  `${sharedConstants.REALTIME_NOTIFIER.event.async_result_chunk_event_prefix}${jobToken}`;
